import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Grid from 'src/ui/library/Grid/Grid';
import Search from '@mui/icons-material/Search';
import classNames from 'classnames';
import history from 'src/store/history';
import GlobalMenu from 'src/ui/library/GlobalMenu/GlobalMenuContainer';
import intl from 'react-intl-universal';
import Tab from 'src/ui/library/Tab';
import {
  ADMIN_URL,
  APP_UPDATE_URL,
  CASE_UPLOAD_URL,
  CASES_URL,
  CONSENT_URL,
  DASHBOARD_URL,
  DOCUMENTS_URL,
  ENGAGEMENTS_URL,
  ENGAGEMENT_GROUP_URL,
  HELP_URL,
  IDVALIDATOR_URL,
  LOBBY_MESSAGE_URL,
  OVERVIEW_CASES_URL,
  PAYWALLREQUESTQUEUE_URL,
  PREREGISTER_APPLICANTS_URL,
  PROFORMA_UPLOAD,
  QUESTIONNAIRE_URL,
  TAXCHAT_SERVICE_INITIATION_URL,
  TEAM_CASES_URL,
  USERS_URL,
} from 'src/constants/constants.js';

const desktopInlineDisplay = {
  display: 'none',
  '@media (min-width: 960px)': {
    display: 'inline',
  },
};

const desktopBlockDisplay = {
  display: 'none',
  '@media (min-width: 960px)': {
    display: 'block',
  },
};

const mobileInlineDisplay = {
  display: 'inline',
  '@media (min-width: 960px)': {
    display: 'none',
  },
};

const HeaderPres = ({ headerName, isMobile }) => {
  const headerClass = classNames('header-container', {
    'header-mobile': isMobile,
  });

  const currentlocation = window.location.href;
  const showdashboard = currentlocation.includes('/powerbi');
  const labels = [headerName];
  const path = {
    // Administration: ADMIN_URL,
    'App Version Update Management': APP_UPDATE_URL,
    'Bulk Updates Management': PREREGISTER_APPLICANTS_URL,
    'Case Management': DOCUMENTS_URL,
    'Case Upload Management': CASE_UPLOAD_URL,
    Dashboard: DASHBOARD_URL,
    'Engagement Group': ENGAGEMENT_GROUP_URL,
    'Engagement Management': ENGAGEMENTS_URL,
    Help: HELP_URL,
    'ID Validator': IDVALIDATOR_URL,
    'Legal Consent': CONSENT_URL,
    'Lobby Message': LOBBY_MESSAGE_URL,
    'My Cases': CASES_URL,
    'Overview Cases': OVERVIEW_CASES_URL,
    'Paywall Management': PAYWALLREQUESTQUEUE_URL,
    'Proforma Upload Management': PROFORMA_UPLOAD,
    // Questionnaire: QUESTIONNAIRE_URL,
    'Service Initiation': TAXCHAT_SERVICE_INITIATION_URL,
    'Team Cases': TEAM_CASES_URL,
    Users: USERS_URL,
  };

  const navigateToHeaderPath = () => {
    if (path[headerName]) history.push(path[headerName]);
  };

  return showdashboard && showdashboard ? null : (
    <Fragment>
      <header className={headerClass}>
        <Grid className="logo-container">
          <div className="logo-image">
            <img alt="Logo" src={process.env.PUBLIC_URL + '/images/EYLogo.svg'} />
          </div>
          <Box component="span" sx={desktopInlineDisplay}>
            <span className="header-iml">
              <span className="header-text">{intl.get('header.headerName')}</span>
            </span>
          </Box>
          <Box component="span" sx={mobileInlineDisplay}>
            <span className="title-mobile">{headerName}</span>
          </Box>
          <nav className="nav-bar">
            <div className="header-button">
              <Search className="icon md" />
            </div>
            <GlobalMenu />
          </nav>
        </Grid>
        <Box component="h2" className="title" sx={desktopBlockDisplay}>
          <Tab
            labels={labels}
            styleType="primary"
            defaultValue={0}
            handleChangeStatus={navigateToHeaderPath}
            onClick={navigateToHeaderPath}
          />
        </Box>
      </header>
    </Fragment>
  );
};

HeaderPres.propTypes = {
  headerName: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default HeaderPres;
